/** Schéma projet Kuunda : `proj_` + UUID 32 hex, jamais `public`, jamais la ref courte. */
export const KUUNDA_DB_SCHEMA_RE = /^proj_[0-9a-f]{32}$/i;
/** Ref projet 8 caractères (hôte `{ref}.kuunda-cloud.com` ou `X-Project-Ref`). */
export const KUUNDA_PROJECT_REF_RE = /^[a-z0-9]{8}$/i;
const HOSTED_REF_RE = /^([a-z0-9]{8})\.kuunda-cloud\.com$/i;

export function isValidDbSchema(schema: string): boolean {
  return KUUNDA_DB_SCHEMA_RE.test(schema.trim());
}

export function isValidProjectRef(ref: string): boolean {
  return KUUNDA_PROJECT_REF_RE.test(ref.trim());
}

export function projectRefFromKuundaUrl(url: string): string | undefined {
  try {
    const host = new URL(url).hostname.toLowerCase();
    const match = host.match(HOSTED_REF_RE);
    return match?.[1];
  } catch {
    return undefined;
  }
}

/** Ref 8 caractères pour OAuth : hôte `{ref}.kuunda-cloud.com` ou `VITE_KUUNDA_PROJECT_REF`. */
export function projectRefForOAuth(url: string, configuredRef?: string): string | undefined {
  const fromUrl = projectRefFromKuundaUrl(url);
  if (fromUrl) return fromUrl;
  const trimmed = configuredRef?.trim().toLowerCase();
  if (!trimmed) return undefined;
  if (!isValidProjectRef(trimmed)) return undefined;
  return trimmed;
}

/** Slug GoTrue Kuunda : `provider=google` côté SDK → `custom:proj-{ref}-google` en URL brute. */
export function kuundaGoogleOAuthProvider(ref: string): string {
  return `custom:proj-${ref.trim().toLowerCase()}-google`;
}

/**
 * `projectRef` peut être omis seulement si l’URL est déjà `https://{ref}.kuunda-cloud.com`.
 * Sinon (api.kuunda-cloud.com, domaine custom) il faut le passer.
 */
export function resolveProjectRef(url: string, configuredRef?: string): string | undefined {
  const fromUrl = projectRefFromKuundaUrl(url);
  if (fromUrl) return undefined;
  const trimmed = configuredRef?.trim();
  if (!trimmed) return undefined;
  if (!isValidProjectRef(trimmed)) {
    throw new Error(
      `[ISBD] KUUNDA_PROJECT_REF invalide (${trimmed}). Attendu : 8 caractères alphanumériques.`,
    );
  }
  return trimmed.toLowerCase();
}

export function assertDbSchema(schema: string): string {
  const value = schema.trim();
  if (!value || value === 'public') {
    throw new Error(
      '[ISBD] KUUNDA_DB_SCHEMA manquant ou égal à « public ». Utilisez proj_ suivi de l’UUID projet (32 hex, sans tirets).',
    );
  }
  if (!isValidDbSchema(value)) {
    throw new Error(
      `[ISBD] KUUNDA_DB_SCHEMA invalide (${value}). Format : proj_ + 32 hex (UUID sans tirets), jamais la ref courte.`,
    );
  }
  return value.toLowerCase();
}
